import { createFileRoute } from '@tanstack/react-router';
import z from 'zod';
import { ProjectDetailMemoPage } from '@/pages/projects/ui/ProjectDetailMemoPage';
import { routeValidateQuerySearch } from '@/shared/lib/route';
import { projectDetailTabSchema } from '@/widgets/right-side-menu/ui/ai-chat/project-detail/projectDetailTab';

const querySchema = z.object({
  /** AIチャットのスレッドID（事業詳細と共通の AI パネルで使用） */
  threadId: z.string().optional(),
  /** 現在開いているメモID（リロード時に状態復元するため URL に反映） */
  memoId: z.string().optional(),
  /** AIサイドパネルの選択タブ（matching / chat）。未指定時は chat 相当 */
  tab: projectDetailTabSchema.optional(),
});

export const Route = createFileRoute('/_protected/projects/$projectId/memo')({
  component: ProjectDetailMemoPage,
  validateSearch: (record) =>
    routeValidateQuerySearch({
      record,
      usePaginationSchema: false,
      customSchema: querySchema,
      defaultValues: {},
    }),
});
